module.exports = __webpack_public_path__ + "img/image147.4eb1f768.jpg";